import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Injector, NgZone, PLATFORM_ID } from '@angular/core';
import { WINDOW } from '@df/dom/globals';
import { inject } from '@angular/core';
import { IDfConfig } from '@df/core/df-core.config';
import { Nexus } from '@tomandco/nexus-api-types';

declare global {
    interface Window {
        app: App;
    }
}

export let app: App;

@Injectable({
    providedIn: 'root'
})
export class App {
    readonly isPlatformBrowser: boolean;
    hasSSRCode: boolean = false;
    readonly ngZoneOff: boolean;
    readonly window = inject(WINDOW);

    /**
     * Dragonfly configuration comming from yaml files thruough df.config.twig.part files
     */
    get dfConfig(): IDfConfig {
        return this.window.dfConfig as IDfConfig;
    }

    get data(): Nexus.Lib.General.AppData {
        return this.apiConfigService.apiConfig!;
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        readonly injector: Injector,
        ngZone: NgZone
    ) {
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
        this.ngZoneOff = ngZone.isStable;
        // this.deployConfigs(this.window.dfConfig, this.window.autoInitData?.website);

        app = this;
        if (this.isPlatformBrowser) {
            window.app = this;
        }
    }

    // private deployConfigs(dfConfig: Partial<IDfConfig> | undefined, data: Nexus.Lib.General.AppData): void {
    //     const partial = {
    //         ...App.initialConfig,
    //         ...this.DRAGONFLY_CONFIG
    //     };

    //     for (const key in partial) {
    //         if (dfConfig && dfConfig[key]) {
    //             Object.assign(partial[key], dfConfig[key]);
    //         }
    //     }
    //     this.dfConfig = <IDfConfig>{ ...dfConfig, ...partial };
    //     this.data = data;

    //     if (this.dfConfig.endpoint) {
    //         this.dfConfig.endpoint.nodeApi = this.dfConfig.endpoint.nodeApi.replace(/\/+$/, '') + '/';
    //         this.dfConfig.endpoint.phpApi = this.dfConfig.endpoint.phpApi.replace(/\/+$/, '') + '/';
    //     }
    // }

    // get currencySymbol(): string | undefined {
    //     const base = this.data.currency.base;

    //     const currency = this.data.currency.list.find(curr => curr.code === base);
    //     if (currency) {
    //         return currency.symbol;
    //     }
    //     return undefined;
    // }
}
